import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";

/**
 * Repository callable brief (Sesi L11, pola sourceStore/reportStore).
 * Tanpa tulis Firestore dari browser; seluruh tulis lewat Admin SDK.
 */
export async function getSourceBrief(bookId) {
  if (typeof bookId !== "string" || bookId.trim().length === 0) {
    return { error: "missing" };
  }
  try {
    const fn = httpsCallable(functions, "getSourceBrief");
    const res = await fn({ bookId });
    if (res.data?.ok && res.data.brief) {
      return { brief: res.data.brief };
    }
    return { error: "missing" };
  } catch (err) {
    if (err?.code === "functions/not-found") return { error: "missing" };
    if (err?.code === "functions/permission-denied") return { error: "locked" };
    return { error: "read" };
  }
}
